import React, {useState} from "react";
import TextInput from "../../Components/Inputs/TextInput";
import ReactSelectInput from "../../Components/Inputs/ReactSelectInput";
import NumberInput from "../../Components/Inputs/NumberInput";
import DateTimeInput from "../../Components/Inputs/DateTimeInput";
import ReactMultiSelectAsync from "../../Components/Inputs/ReactMultiSelectAsync";
import axios from "axios";
import ReactMultiSelectInput from "../../Components/Inputs/ReactMultiSelectInput";
import SingleCheckbox from "../../Components/Inputs/SingleCheckbox";

export default function ({register, errors, control, getValues, watch, data}) {
  const [filteredProducts, setFilteredProducts] = useState([]);

  const searchProduct = (val) => {
    return axios.get('search-products-list', {
      params: {
        keyword: val,
        product_ids: getValues('products'),
        shops: watch('shops'),
        brands: watch('brands'),
        categories: getValues('categories')
      }
    }).then(res => {
      setFilteredProducts(res.data?.products);
      return res.data?.products;
    });
  }

  return (
    <>
      <TextInput
        label='Name'
        name='name'
        register={register}
        errorMessage={errors?.name}
        required
      />

      {!data.isEditMode && (
        <TextInput
          label='Code'
          name='code'
          register={register}
          errorMessage={errors?.code}
        />
      )}

      <ReactSelectInput
        label='Type'
        name='type'
        control={control}
        errorMessage={errors?.type}
        options={data?.couponTypes}
        required
      />

      <ReactSelectInput
        label='Action type'
        name='action_type'
        control={control}
        errorMessage={errors?.action_type}
        options={data?.couponActionTypes}
        required
      />

      <TextInput
        label='Amount'
        name='amount'
        register={register}
        errorMessage={errors?.amount}
        required
      />

      <TextInput
        label='Min order price'
        name='min_order_price'
        register={register}
        errorMessage={errors?.min_order_price}
      />

      <NumberInput
        label='Usages'
        name='usages'
        register={register}
        errorMessage={errors?.usages}
        required
      />

      <DateTimeInput
        label='Date from'
        name='date_from'
        register={register}
        errorMessage={errors?.date_from}
        control={control}
        required
      />

      <DateTimeInput
        label='Date to'
        name='date_to'
        register={register}
        errorMessage={errors?.date_to}
        control={control}
        required
      />

      {
        //2 means products
        (watch('action_type') === 2) && (
          <>
            <ReactMultiSelectInput
              label="Shops"
              name="shops"
              placeholder="Choose Shops"
              parentClasses="mt-5"
              inputClassName="col-md-6"
              register={register}
              values={data?.shops}
              errorMessage={errors?.shops}
              control={control}
            />

            <ReactMultiSelectInput
              label="Brands"
              name="brands"
              placeholder="Choose brands"
              parentClasses="mt-5 mb-5"
              inputClassName="col-md-6"
              register={register}
              values={data?.brands}
              errorMessage={errors?.brands}
              control={control}
            />

            <ReactMultiSelectInput
              label="Categories"
              name="categories"
              placeholder="Choose categories"
              parentClasses="mt-5 mb-5"
              inputClassName="col-md-6"
              register={register}
              values={data?.categories}
              errorMessage={errors?.categories}
              control={control}
            />

            <ReactMultiSelectAsync
              label="Products"
              name="products"
              placeholder="Choose Products"
              className="col-md-12 col-sm-6 pt-3"
              inputClassName="col-md-6"
              parentClasses='fv-row mb-2'
              values={filteredProducts} //options
              errorMessage={errors?.products}
              control={control}
              search={searchProduct}
              defaultOptions={true}
              loadTrigger={watch('products')}
            />
            <SingleCheckbox
              name="exclude_discounted_products"
              register={register}
              label="No discount (Exclude discounted products)"
            />
          </>
        )
      }
    </>
  );
}